const LAST_SEEN_SYNC_EVENT = "new-indicator:lastSeen";

export function emitLastSeenSync(target, category, value) {
  if (!target?.dispatchEvent) return;

  target.dispatchEvent(
    new CustomEvent(LAST_SEEN_SYNC_EVENT, {
      detail: { category, value },
    }),
  );
}

export function subscribeLastSeenSync(target, category, callback) {
  if (!target?.addEventListener) return () => {};

  const handleCustomEvent = (event) => {
    if (event?.detail?.category !== category) return;
    callback(event.detail.value);
  };

  target.addEventListener(LAST_SEEN_SYNC_EVENT, handleCustomEvent);

  return () => {
    target.removeEventListener(LAST_SEEN_SYNC_EVENT, handleCustomEvent);
  };
}
